module.exports = __webpack_public_path__ + "static/app-icon-82b56fd9c7606dd900c53cb902293d3f.png";